export const ADMINISTRATOR = 10; // 管理员
export const TEACHER = 30; // 老师
export const Agency = 20; // 机构

export const INDENTITY_VALID_ENABLE = 10; // 启用
export const INDENTITY_VALID_DISABLE = 30; // 禁用

export const IS_SHOW_MAP_DISABLE = 0; // 不显示精品课程
export const IS_SHOW_MAP_ENABLE = 1; // 显示精品课程

export const IS_STUDENT_NO_BUY = 0; // 学员未购买
export const IS_STUDENT_BUY = 1; // 学员已购买

export const ADVERTISING_VALID_ENABLE = 10; // 广告启用
export const ADVERTISING_VALID_DELETE = 20; // 删除
export const ADVERTISING_VALID_DISABLE = 30; // 禁用

export const DISTRIBUTION_EXTRACT_ENABLE = 10; // 提取
export const DISTRIBUTION_EXTRACT_DISABLE = null; // 未提取

export const PRODUCT_ENABLE = 10; // 上架
export const PRODUCT_DISABLE = 30; // 下架

export const PRODUCT_ISUSE = 1; // 商品已经使用
export const PRODUCT_NOUSE = 0; // 商品未使用

export const COUNSELOR_ENABLE = 10; // 辅导员启用
export const COUNSELOR_DISABLE = 30; // 禁用

export const COUNSELOR_CHECKVIDEO = 1; // 视频审核权限 有
export const COUNSELOR_NOCHECKVIDEO = 0; // 视频审核权限 没有

export const COURSE_CATEGORY_ENABLE = 10; // 课程类型启用
export const COURSE_CATEGORY_DISABLE = 30; // 课程类型禁用

export const COURSE_ENABLE = 10; // 课程启用
export const COURSE_DELETE = 20; // 课程删除
export const COURSE_DISABLE = 30; // 课程禁用

export const COURSE_COMMENT_ENABLE = 1; // 评价已显示
export const COURSE_COMMENT_DISABLE = 0; // 评价已隐藏

export const IS_USE = 0; // 可用
export const IS_NO_USE = 1; // 不可用

export const IS_REFUND = 0; // 未退款
export const IS_NO_REFUND = 1; // 已退款

export const EVALUATION_ENABLE = 10; // 上架
export const EVALUATION_DISABLE = 30; // 下架

export const AGENT_ENABLE = 10; // 启用
export const AGENT_DELETE = 20; // 启用
export const AGENT_DISABLE = 30; // 禁用

export const EVALUATION_CATEGORY_ENABLE = 10; // 启用
export const EVALUATION_CATEGORY_DELETE = 20; // 删除
export const EVALUATION_CATEGORY_DISABLE = 30; // 禁用

export const COUPON_ENABLE = 10; // 启用
export const COUPON_DELETE = 20; // 删除
export const COUPON_DISABLE = 30; // 禁用